export const UserCreateForm = ({ form, message, onChange, onSubmit }) => (
  <form className="card border-0 p-4" onSubmit={onSubmit}>
    <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
      <div>
        <span className="users-eyebrow">User Management</span>
        <h4 className="m-0">Add New User</h4>
      </div>
      <i className="bi bi-person-plus fs-2 text-success" />
    </div>

    <div className="row g-3 align-items-end">
      <div className="col-12 col-lg-6">
        <label className="form-label" htmlFor="username">Email</label>
        <input
          id="username"
          name="username"
          type="email"
          className="form-control"
          placeholder="admin@example.com"
          value={form.username}
          onChange={(event) => onChange({ ...form, username: event.target.value })}
        />
      </div>

      <div className="col-12 col-lg-4">
        <label className="form-label" htmlFor="selectTier">Role</label>
        <select
          id="selectTier"
          className="form-select"
          value={form.role}
          onChange={(event) => onChange({ ...form, role: event.target.value })}
        >
          <option value="staff">Staff - Downloads Only</option>
          <option value="admin">Admin - Full Access</option>
        </select>
      </div>

      <div className="col-12 col-lg-2">
        <button className="btn btn-success w-100" type="submit">
          <i className="bi bi-plus-lg me-2" />
          Add
        </button>
      </div>
    </div>

    {message && <p className="alert alert-light m-0 mt-3 text-center text-break">{message}</p>}
  </form>
);
